import Fetcher from 'middlewares/Fetcher';
import { DownloadResponse } from 'api/APIRest';
import { downloadBlobFile } from 'utils/downloadBlobFile';
import { LoanOriginationSystemProductsActionType } from './ActionTypes';
import {
  DownloadApiRequestTemplateAction,
  downloadApiRequestTemplateFailure,
  downloadApiRequestTemplateSuccess,
} from './ActionCreator';
import { ApiRequestTemplatesApi } from 'api/LoanOriginationSystem/ApiRequestTemplatesApi';

const DownloadApiRequestTemplateMiddleware = (api: ApiRequestTemplatesApi) =>
  Fetcher<DownloadResponse, DownloadApiRequestTemplateAction>(
    LoanOriginationSystemProductsActionType.DownloadApiRequestTemplate,
    downloadApiRequestTemplateSuccess,
    downloadApiRequestTemplateFailure,
    async (action) => {
      const response = await api.downloadProductApiRequestTemplate(
        action.payload.productId,
        action.payload.requestType,
      );

      downloadBlobFile(response);

      return response;
    },
  );

export default DownloadApiRequestTemplateMiddleware;
